/*
 * Copyright (c) 2019 brightlamp
 */

import { axiosInit } from './axiosSetup'

export default
{
    namespaced: true,
    state:
    {
        paymentInfo: {cards:[]},
        error: null,
        orgTestRequestCount: 0
    },
    mutations:
    {
        INIT_CUSTOMER_BILLING(state)
        {
            state.paymentInfo = {cards:[]};
            state.orgTestRequestCount = 0
        },
        SET_ERROR(state, payload)
        {
            state.error = payload
        },
        CLEAR_ERROR(state)
        {
            state.error = null
        },
        SET_PAYMENT_INFO(state, payload)
        {
            state.paymentInfo = payload
        },
        SET_ORG_TEST_REQUEST_COUNT(state, payload)
        {
            const nfObject = new Intl.NumberFormat(navigator.languages[0]);
            state.orgTestRequestCount = nfObject.format(payload)
        }
    },
    actions:
    {
        GET_PAYMENT_INFO: async (context) =>
        {
            const axios = await axiosInit();
            const response = await axios.get('/user/payment-info');
            if (response.headers['content-length'] && response.headers['content-length'] !== '0')
            {
                context.commit('SET_PAYMENT_INFO', response.data)
            }
            else
            {
                context.commit('SET_PAYMENT_INFO', {cards:[]})
            }
        },
        SET_PAYMENT_INFO: async (context, payload) =>
        {
            const axios = await axiosInit();
            const response = await axios.post('/user/self/payment-info', payload);
            context.commit('SET_PAYMENT_INFO', response.data)
        },
        GET_ORG_PAYMENT_INFO: async (context, payload) =>
        {
            const axios = await axiosInit();
            const response = await axios.get(`/org/${payload}/payment-info`);
            context.commit('SET_PAYMENT_INFO', response.data)
        },
        SET_ORG_PAYMENT_INFO: async (context, payload) =>
        {
            const axios = await axiosInit();
            const response = await axios.post(`/org/${payload.orgId}/payment-info`, payload.data);
            context.commit('SET_PAYMENT_INFO', response.data)
        },
        GET_TEST_REQUEST_COUNT_FOR_CURRENT_PERIOD: async (context) =>
        {
            const axios = await axiosInit();
            const response = await axios.get('/telehealth/billing');
            context.commit('SET_ORG_TEST_REQUEST_COUNT', response.data.totalUsage)
        }
    }
}